import React, { PropTypes } from 'react';

import { NitroParagraph } from 'nitro-components';

import moment from 'moment';

import styled from 'styled-components';

const History = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const CostcenterHistory = ({ list }) => {
  return (
    <History>
      {list.map((item, index) => {
        const startDate = moment(item.StartDate, 'YYYY-MM-DD').format('Do MMM YYYY').toString();
        const endDate = moment(item.EndDate, 'YYYY-MM-DD').format('Do MMM YYYY').toString();
        return (
          <li key={index}>
            <NitroParagraph noMargin>{item.CompanyName}</NitroParagraph>
            <NitroParagraph variant="base3" noMargin>{`${startDate} - ${endDate}`}</NitroParagraph>
          </li>
        );
      })}
    </History>
  );
};

CostcenterHistory.propTypes = {
  list: PropTypes.array
};

export default CostcenterHistory;



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/components/CostcenterHistory.js